import type { FallbackImageType } from '@xing-com/super-ellipse';

export const convertUserGender = (
  gender: string | null = ''
): FallbackImageType => {
  if (gender === 'MALE') return 'male-user';
  if (gender === 'FEMALE') return 'female-user';
  return 'neutral-user';
};
